import { Injectable } from '@angular/core';
import { catchError, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';

/**
 * Registra en API acciones iniciadas solo en el navegador (p. ej. JSON/medios vía blob o data URL).
 * Los errores se ignoran para no interferir con la descarga.
 */
@Injectable({
	providedIn: 'root',
})
export class UserActivityTrackService extends ApiService {
	/**
	 * @param link Ruta SPA con UUID reconocible por el backend (`UserActivityLinkHelper::extractSubjectUuid`).
	 */
	public trackClientDownload(params: {
		type: 'processes' | 'operations' | 'workflows';
		action: 'downloaded_json' | 'downloaded_media';
		link: string;
		company_uuid?: string;
	}): void {
		const body: Record<string, string> = {
			type: params.type,
			action: params.action,
			link: params.link,
		};
		if (params.company_uuid) {
			body['company_uuid'] = params.company_uuid;
		}

		this.http
			.post(`${environment.apiUrl}/user-activity`, body, { headers: this.getHeaders() })
			.pipe(catchError(() => of(null)))
			.subscribe();
	}
}
